import { Box, Grid, Hidden, makeStyles } from "@material-ui/core";
import { size } from "@mvp/design-system";
import React, { useEffect, useState } from "react";
import { Router, useLocation } from "react-router-dom";
import routes from "../routes";
import history from "../utils/history";
import { DonateLifeFooter } from "./DonateLifeFooter";
import { ImagePanel } from "./ImagePanel";
import NavigationButtons from "./shared/NavigationButtons";
import { MobilePlanOverview } from "./shared/planOverview/MobilePlanOverview";
import PlanOverview from "./shared/planOverview/PlanOverview";
import SideBar from "./shared/sidebar/SideBar";

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    textAlign: "end",
  },
  container: {
    width: "100%",
    display: "flex",
    boxSizing: "border-box",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  content: {
    maxWidth: "68.75rem",
    display: "block",
    padding: `0 4.5rem`,

    [theme.breakpoints.down("lg")]: {
      padding: `0 0 0 2.5rem`,
    },
    [theme.breakpoints.down("sm")]: {
      padding: size.m(theme),
    },
    flexGrow: 1,
    overflowX: "hidden",
  },
  buttonOffSet: {
    marginBottom: "3rem",
    paddingRight: "2.5rem",
    [theme.breakpoints.only("xl")]: {
      minHeight: "46.688rem",
    },
    [theme.breakpoints.between("md", "lg")]: {
      minHeight: "32rem",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: 0,
      paddingRight: 0,
    },
  },
}));

export const Page: React.FC = (props) => {
  const classes = useStyles();
  const donateLife = useLocation().pathname === routes.subscriberInfo.donateLifeInfo;

  return (
    <Router history={history}>
      <Box className={classes.container}>
        <SideBar />
        <Grid container className={classes.content}>
          <Grid item container xs={12}>
            <PlanOverviewContainer />

            <Grid item container xs={12} md={8} xl={12}>
              <>
                <div className={classes.buttonOffSet}>{props.children}</div>
                <Hidden mdUp>
                  <MobilePlanOverview />
                </Hidden>
              </>
            </Grid>
            <Hidden smDown xlUp>
              <Grid item md={4} className={classes.imageContainer}>
                <ImagePanel />
              </Grid>
            </Hidden>
            <NavigationButtons />
            {donateLife && <DonateLifeFooter />}
          </Grid>
        </Grid>
        <Hidden lgDown>
          <ImagePanel />
        </Hidden>
      </Box>
    </Router>
  );
};

const PlanOverviewContainer = () => {
  const location = useLocation();
  const [showPlanOverview, setShowPlanOverview] = useState(false);

  useEffect(() => {
    const inReviewSection: boolean = location.pathname.includes(
      routes.reviewSelection.base
    );
    if (inReviewSection) {
      showPlanOverview && setShowPlanOverview(false);
    } else {
      !showPlanOverview && setShowPlanOverview(true);
    }
  }, [location]);

  return (
    <>
      {showPlanOverview ? (
        <Hidden smDown>
          <Grid item xs={12}>
            <PlanOverview />
          </Grid>
        </Hidden>
      ) : null}
    </>
  );
};
